import { types } from "./types/types"


const initialState = {
    loading: false,
    loadingCargo: false,
    loadingDepartamento: false,
    loadingSucursal: false
}


export const ui = (state = initialState, action) => {
    switch (action.type) {
        case types.uiClearState:
            return initialState
        // loading
        case types.uiStartLoading:
            return {
                ...state,
                loading: true
            }
        case types.uiFinishLoading:
            return {
                ...state,
                loading: false
            }
        // loading cargo
        case types.uiStartLoadingCargo:
            return {
                ...state,
                loadingCargo: true
            }
        case types.uiFinishLoadingCargo:
            return {
                ...state,
                loadingCargo: false
            }
        // loading departamento
        case types.uiStartLoadingDepartamento:
            return {
                ...state,
                loadingDepartamento: true
            }
        case types.uiFinishLoadingDepartamento:
            return {
                ...state,
                loadingDepartamento: false
            }
        // loading sucursal
        case types.uiStartLoadingSucursal:
            return {
                ...state,
                loadingSucursal: true
            }
        case types.uiFinishLoadingSucursal:
            return {
                ...state,
                loadingSucursal: false
            }
        default:
            return state
    }
}


